import React from "react";

export const videoPack = (
  isIOS: boolean,
  videoUrl: string,
  setIsVideoLoaded: (isVideoLoaded: boolean) => void
) => {
  if (isIOS) {
    return (
      <video
        className="w-full h-full object-contain"
        controls
        autoPlay
        playsInline
        muted
        loop
        poster={videoUrl}
        onLoadedData={() => setIsVideoLoaded(true)}
      >
        <source src={videoUrl} type="video/mp4" />
      </video>
    );
  } else {
    if (!videoUrl) return null;
    return (
      <video
        className="w-full h-full object-cover"
        controls
        autoPlay
        playsInline
        muted
        loop
        poster={videoUrl}
        onLoadedData={() => setIsVideoLoaded(true)}
      >
        <source src={videoUrl} type="video/mp4" />
      </video>
    );
  }
};
